var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHeartIn = function SvgHeartIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.892c.098 2.143.895 4.18 2.255 5.755a14.694 14.694 0 003.828 3.366 3.705 3.705 0 004.023-.127c1.313-.898 2.492-2 3.501-3.27 1.384-1.56 2.229-3.58 2.393-5.724a5.21 5.21 0 00-1.246-3.442C13.976.542 12.881.02 11.73.01 10.285-.097 8.889.593 8.028 1.84L8 1.883l-.027-.043C7.189.66 5.909-.026 4.558.01 3.341-.01 2.17.496 1.31 1.417.452 2.337-.02 3.592.001 4.892z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.892c.098 2.143.895 4.18 2.255 5.755a14.694 14.694 0 003.828 3.366 3.705 3.705 0 004.023-.127c1.313-.898 2.492-2 3.501-3.27 1.384-1.56 2.229-3.58 2.393-5.724a5.21 5.21 0 00-1.246-3.442C13.976.542 12.881.02 11.73.01 10.285-.097 8.889.593 8.028 1.84L8 1.883l-.027-.043C7.189.66 5.909-.026 4.558.01 3.341-.01 2.17.496 1.31 1.417.452 2.337-.02 3.592.001 4.892z",
    fill: "url(#heartIn_svg__paint0_linear_10550_212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heartIn_svg__paint0_linear_10550_212",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 14.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4900"
  })))));
};
export default SvgHeartIn;